export default "https://cdn-static.gokick.com/assets/21dc595b281e80327dab5b97c944977d2420b47e/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";